<template>
  <div>
    <v-dialog
      hide-overlay
      v-model="doc_list_modal"
      persistent
      max-width="1300px"
      internal-activator
      style="max-height:none !important;"
    >
      <v-card tile :loading="doc_list_loading">
        <v-card-title class="pa-0">
          <v-row dense no-gutters>
            <v-col class>
              <v-card-title class="pa-0">
                <v-col cols="2">
                  <v-autocomplete
                    dense
                    flat
                    :items="project_status_list"
                    outlined
                    label="Status"
                    class="body-2"
                    placeholder="All"
                    v-model="project_status"
                    hide-details
                    @change="getProjects()"
                    v-if="is_from_dashboard"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    dense
                    flat
                    :items="project_list"
                    outlined
                    label="Project"
                    class="body-2"
                    placeholder="All"
                    v-model="project_id"
                    clearable
                    @click:clear="setDocumentData({key : 'o_id',value : ''})"
                    :error-messages="form_errors.o_id"
                    :hide-details="!form_errors.o_id"
                    v-if="is_from_dashboard"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3" class="text-center">Dox Upload & View</v-col>
                <v-col cols="4">
                  <v-menu
                    bottom
                    :close-on-content-click="false"
                    content-class="elevation-0"
                    v-model="filter_menu"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn">
                        <span class="lable_class">Filter</span>
                        <v-icon size="22px" style="color:#bdbdbd">mdi-filter-menu-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card tile max-width="400" class="mb-5 mr-5">
                      <v-list class="filter-section-border">
                        <v-list-item class="mt-0 float-right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="error"
                                @click="resetFilter()"
                                icon
                                small
                              >
                                <v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon>
                              </v-btn>
                            </template>
                            <span>Reset</span>
                          </v-tooltip>
                        </v-list-item>
                        <v-list-item class="mt-1">
                          <v-autocomplete
                            dense
                            flat
                            :items="doc_module_status_list"
                            outlined
                            label="Document Status"
                            hide-details
                            class="body-2"
                            placeholder="All"
                            v-model="pagination.filters.doc_module_status"
                            clearable
                            v-if="type==8 && main_task_id=='0'"
                          ></v-autocomplete>
                        </v-list-item>
                        <v-list-item class="mt-1">
                          <v-autocomplete
                            dense
                            flat
                            :items="doc_types_filter"
                            outlined
                            label="Document Type"
                            hide-details
                            class="body-2"
                            placeholder="All"
                            v-model="pagination.filters.doc_type"
                            clearable
                          ></v-autocomplete>
                        </v-list-item>
                        <v-list-item class="mt-1">
                          <v-autocomplete
                            dense
                            flat
                            :items="doc_folder_filter"
                            outlined
                            label="Document Folder"
                            hide-details
                            class="body-2"
                            placeholder="All"
                            v-model="pagination.filters.doc_folder"
                            clearable
                          ></v-autocomplete>
                        </v-list-item>
                        <v-list-item class="mt-1">
                          <v-text-field
                            dense
                            flat
                            outlined
                            label="File Name"
                            hide-details
                            class="body-2"
                            placeholder="file"
                            v-model="pagination.filters.doc_file"
                            clearable
                            v-debounce:500="getDocumentsList"
                          ></v-text-field>
                        </v-list-item>
                        <v-list-item class="mt-1">
                          <v-autocomplete
                            dense
                            flat
                            outlined
                            label="Report Type"
                            hide-details
                            class="body-2"
                            placeholder="All"
                            v-model="pagination.filters.report_type"
                            clearable
                            :items="report_names"
                            item-text="report_name.name"
                            item-value="report_name_id"
                          ></v-autocomplete>
                        </v-list-item>
                      </v-list>
                      <v-card-title class="pa-0">
                        <v-btn
                          fab
                          color="error"
                          x-small
                          absolute
                          @click="filter_menu = false;resetData();"
                          class="custom-close-btn"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                    </v-card>
                  </v-menu>

                  <v-tooltip bottom v-if="selectedRows2.length > 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        x-small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        @click="deleteDocuments"
                      >
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remove Document(s)</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="selectedRows2.length > 0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        x-small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="email_dialog = true"
                        class="ml-3"
                      >
                        <v-icon>mdi-email</v-icon>
                      </v-btn>
                    </template>
                    <span>Send document(s) in mail</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="selectedRows2.length == 1">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        fab
                        x-small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        class="ml-3"
                        @click="getFileDetail();move_row=true;move_dialog=true;"
                      >
                        <v-icon>mdi-folder-move</v-icon>
                      </v-btn>
                    </template>
                    <span>Move Dropbox File</span>
                  </v-tooltip>
                  <v-btn
                    fab
                    x-small
                    color="primary"
                    class="ml-3"
                    @click="assign_reassign_type_module = true"
                  >
                    <v-icon size="18">mdi-wrench-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-card-title>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 4%;">
              <v-icon size="30" class="m drag-icon">mdi-drag-variant</v-icon>
            </v-col>
            <v-col cols="1" class="mt-2" style="max-width: 5%;">
              <v-btn
                fab
                color="error"
                x-small
                @click="setDocumentData({key : 'doc_list_modal',value : false});setDocumentData({key : 'o_id',value : ''})"
                class="custom-close-btn"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-row dense no-gutters class="grey lighten-1 ma-1 mt-2">
          <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
            <span v-if="bank_name">{{bank_name}}</span>
            <span v-if="item_name">{{item_name}}</span>
            <span v-if="job_name">{{job_name}}</span>
            <span v-if="user_name">{{user_name}}</span>
          </v-col>
          <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
            <span v-if="vendor_name">{{vendor_name}}</span>
            <span v-if="customer_name">{{customer_name}}</span>
          </v-col>
          <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
            <span v-if="project_name">{{project_name}}</span>
          </v-col>
          <v-col cols="3" class="text-center">
            <span v-if="form_name">{{form_name}}</span>
          </v-col>
        </v-row>
        <v-card-text class="pa-1 mx-auto">
          <v-row dense no-gutters>
            <v-col cols="3" style="max-width: 24.7%;">
              <v-autocomplete
                outlined
                label="Doc Type"
                dense
                :hide-details="!form_errors.doc_type"
                :items="doc_types"
                v-model="form_data_temp.doc_type"
                :error-messages="form_errors.doc_type"
                @change="setDocTitle()"
                clearable
                :disabled="move_row"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" style="max-width: 21%;" class="ml-2" v-if="is_extra_folder">
              <v-autocomplete
                dense
                flat
                :items="customer_list"
                item-text="text"
                item-value="text"
                outlined
                label="Customer"
                small
                class="body-2"
                placeholder="Customer"
                clearable
                v-if="form_data_temp.extra_folder==1"
                v-model="form_data_temp.doc_title"
                :error-messages="form_errors.doc_title"
                :hide-details="!form_errors.doc_title"
                :disabled="move_row"
              ></v-autocomplete>
              <!-- <v-autocomplete
                  dense
                  flat
                  :items="vendor_list"
                  item-text="text"
                  item-value="text"
                  outlined
                  label="Vendor"
                  small
                  class="body-2"
                  placeholder="Vendor"
                  clearable
                  v-if="form_data_temp.extra_folder==2"
                  v-model="form_data_temp.doc_title"
                  :error-messages="form_errors.doc_title"
                  :hide-details="!form_errors.doc_title"       
              ></v-autocomplete>-->

              <v-autocomplete
                dense
                flat
                :items="chart_of_account_list"
                item-text="text"
                item-value="text"
                v-model="form_data_temp.doc_title"
                outlined
                small
                v-if="form_data_temp.extra_folder==2 && form_data_temp.expence"
                clearable
                class="body-2 focus-on-vendor-expence3"
                label="Chart Of Account"
                :error-messages="form_errors.doc_title"
                :hide-details="!form_errors.doc_title"
                :disabled="move_row"
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="form_data_temp.expence = false; setFocus('focus-on-vendor-expence3');"
                  >Select Vendor</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>

              <v-autocomplete
                dense
                :items="vendor_list"
                v-model="form_data_temp.doc_title"
                item-text="text"
                item-value="text"
                outlined
                small
                clearable
                label="Vendor"
                class="body-2 focus-on-vendor-expence3"
                v-else
                :error-messages="form_errors.doc_title"
                :hide-details="!form_errors.doc_title"
                :disabled="move_row"
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="
                      form_data_temp.expence = true;
                      setFocus('focus-on-vendor-expence3');
                    "
                  >Select Chart of Account</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>

              <v-autocomplete
                dense
                flat
                :items="chart_of_account_list"
                item-text="text"
                item-value="text"
                outlined
                label="Chart Of Account"
                small
                class="body-2"
                placeholder="Chart Of Account"
                clearable
                v-if="form_data_temp.extra_folder==3"
                v-model="form_data_temp.doc_title"
                :error-messages="form_errors.doc_title"
                :hide-details="!form_errors.doc_title"
                :disabled="move_row"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" style="max-width: 21%;" class="ml-2" v-else>
              <v-text-field
                outlined
                label="Doc. Name"
                v-model="form_data_temp.doc_title"
                dense
                :disabled="form_data_temp.doc_type != 27"
                :error-messages="form_errors.doc_title"
                :hide-details="!form_errors.doc_title"
              ></v-text-field>
            </v-col>
            <v-col
              cols="1"
              style="min-width: 8.5%;"
              v-if="!move_row"
              class="py-0 d-flex align-center ml-2"
            >
              <v-switch
                label="Dropbox"
                hide-details
                v-model="form_data_temp.is_dropbox"
                @change="dragging = false;form_data_temp.file==''"
                class="my-0"
              ></v-switch>
            </v-col>
            <v-col cols="3" v-if="edit_mode" class="ml-2">
              <v-text-field
                outlined
                label="Doc. Name"
                v-model="form_data_temp.client_name"
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="3" style="max-width: 50%;" class="ml-2" v-else>
              <div v-if="!form_data_temp.is_dropbox">
                <div v-if="!form_data_temp.file">
                  <div
                    :class="['dropZone', dragging ? 'dropZone-over' : '']"
                    @dragenter="dragging = true"
                    @dragleave="dragging = false"
                  >
                    <div class="dropZone-info" @drag="onChange">
                      <span class="fa fa-cloud-upload dropZone-title"></span>
                      <span class="dropZone-title">Drop file or click to upload</span>
                    </div>
                    <input type="file" @change="onChange" />
                  </div>
                  <div class="error_message" v-if="form_errors.file">{{form_errors.file[0]}}</div>
                </div>
                <div v-else class="dropZone-uploaded">
                  <div class="dropZone-uploaded-info d-flex">
                    <div class="dropZone-title">
                      {{ form_data_temp.file_name ? form_data_temp.file_name.substring(0,20)+"...." :''}}{{"("+formatBytes(form_data_temp.file.size ? form_data_temp.file.size :'')+")"}}
                      <button
                        type="button"
                        class="removeFile ml-2"
                        @click="removeFile"
                      >
                        <v-icon class="close_icon">mdi-close</v-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <v-file-input
                  v-model="form_data_temp.file"
                  color="primary"
                  label="Upload Document"
                  placeholder="Select your file"
                  outlined
                  :show-size="1000"
                  dense=""
                  drop="true"
                  :error-messages="form_errors.file"
                  :hide-details="!form_errors.file"
                  v-if="!form_data_temp.is_dropbox"
                >
              </v-file-input>-->
              <VueDropboxPicker
                :api-key="dropboxApiKey"
                link-type="direct"
                :multiselect="false"
                :folderselect="false"
                @cancel="onCancel"
                @picked="onPicked"
                v-show="form_data_temp.is_dropbox"
              >
                <v-text-field
                  v-model="form_data_temp.file_name"
                  color="primary"
                  label="Select Document"
                  placeholder="Click to select"
                  append-icon="mdi-dropbox"
                  prepend-icon
                  outlined
                  dense
                  readonly
                  :error-messages="form_errors.link"
                  :hide-details="!form_errors.link"
                ></v-text-field>
              </VueDropboxPicker>
            </v-col>
            <v-col class="ml-2">
              <button
                type="button"
                class="renameFile"
                v-if="!form_data_temp.is_dropbox && form_data_temp.file_name && !move_row"
                @click="renameFile"
              >
                <v-icon class="mdi-tooltip-edit">mdi-tooltip-edit</v-icon>
              </button>
              <button
                type="button"
                class="renameFile"
                v-if="form_data_temp.is_dropbox && form_data_temp.dropbox_file.name"
                @click="renameDropBoxFile"
              >
                <v-icon class="mdi-tooltip-edit">mdi-tooltip-edit</v-icon>
              </button>
              <v-btn
                class="ml-2"
                color="primary"
                :loading="doc_list_loading"
                v-if="!move_row"
                @click="uploafileFolder(form_data_temp); "
              >Upload</v-btn>

              <v-btn
                class="ml-2"
                @click="resetData();"
                v-if="!move_row"
                color="error"
                :disabled="doc_list_loading"
              >Reset</v-btn>
            </v-col>
          </v-row>
          <v-row dense no-gutters class="mt-7" v-if="move_row">
            <v-col cols="3" style="max-width: 20%;" v-if="doc_module!='TRANSACTION'">
              <v-select
                outlined
                :label="doc_module"
                dense
                :hide-details="!form_errors.move_module_item_id"
                :items="module_item_list"
                v-model="form_data_temp.move_module_item_id"
                :error-messages="form_errors.move_module_item_id"
                :readonly="(main_task_id!=0 && main_task_id!='undefined')"
                @change="doc_module=='PROJECT' ? getCustomerName(form_data_temp.move_module_item_id) :''"
              ></v-select>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="ml-2">
              <v-autocomplete
                outlined
                label="Doc Type"
                dense
                :hide-details="!form_errors.move_doc_type"
                :items="doc_types"
                v-model="form_data_temp.move_doc_type"
                :error-messages="form_errors.move_doc_type"
                @change="setMoveDocTitle()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="ml-2" v-if="is_move_extra_folder">
              <v-autocomplete
                dense
                flat
                :items="customer_list"
                item-text="text"
                item-value="text"
                outlined
                label="Customer"
                small
                class="body-2"
                placeholder="Customer"
                clearable
                v-if="form_data_temp.move_extra_folder==1"
                v-model="form_data_temp.move_doc_title"
                :error-messages="form_errors.move_doc_title"
                :hide-details="!form_errors.move_doc_title"
              ></v-autocomplete>
              <v-autocomplete
                dense
                flat
                :items="chart_of_account_list"
                item-text="text"
                item-value="text"
                v-model="form_data_temp.move_doc_title"
                outlined
                small
                v-if="form_data_temp.move_extra_folder==2 && form_data_temp.move_expence"
                clearable
                class="body-2 focus-on-vendor-expence"
                label="Chart Of Account"
                :error-messages="form_errors.move_doc_title"
                :hide-details="!form_errors.move_doc_title"
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="form_data_temp.move_expence = false;setFocus('focus-on-vendor-expence');"
                  >Select Vendor</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>
              <v-autocomplete
                dense
                :items="vendor_list"
                v-model="form_data_temp.move_doc_title"
                item-text="text"
                item-value="text"
                outlined
                small
                clearable
                label="Vendor"
                class="body-2 focus-on-vendor-expence"
                v-else
                :error-messages="form_errors.move_doc_title"
                :hide-details="!form_errors.move_doc_title"
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="form_data_temp.move_expence = true;setFocus('focus-on-vendor-expence');"
                  >Select Chart of Account</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>
              <v-autocomplete
                dense
                flat
                :items="chart_of_account_list"
                item-text="text"
                item-value="text"
                outlined
                label="Chart Of Account"
                small
                class="body-2"
                placeholder="Chart Of Account"
                clearable
                v-if="form_data_temp.move_extra_folder==3"
                v-model="form_data_temp.move_doc_title"
                :error-messages="form_errors.move_doc_title"
                :hide-details="!form_errors.move_doc_title"
              ></v-autocomplete>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="ml-2" v-else>
              <v-text-field
                outlined
                label="Doc. Name"
                v-model="form_data_temp.move_doc_title"
                dense
                :disabled="form_data_temp.move_doc_type != 27"
                :error-messages="form_errors.move_doc_title"
                :hide-details="!form_errors.move_doc_title"
              ></v-text-field>
            </v-col>
            <v-col cols="3" style="max-width: 20%;" class="ml-2">
              <v-text-field
                v-model="form_data_temp.move_file_name"
                color="primary"
                label="File"
                prepend-icon
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col class="ml-2">
              <v-btn
                color="primary"
                :loading="doc_list_loading"
                @click="moveFile(form_data_temp); "
              >Move</v-btn>

              <v-btn
                class="ml-2"
                @click="resetData();"
                color="error"
                :disabled="doc_list_loading"
              >Reset</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- <v-card-text class="pa-1 mx-auto" v-if="type == 8">
          <v-row dense="" no-gutters class="d-flex justify-end">
            <v-col cols="4">
              <v-select
                v-model="pagination.search"
                label="Report"
                placeholder="All"
                outlined=""
                dense=""
                clearable
                hide-details=""
                :items="report_names"
                item-text="report_name.name"
                item-value="report_name_id"
              >
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>-->
        <v-card-text
          class="pa-1 mx-auto"
          style="overflow:auto !important;max-height:584px !important;"
        >
          <v-data-table
            :headers="headers"
            class="elevation-1 rounded-0 my-transaction-table document-list"
            :items="doc_items.data"
            dense
            show-expand
            item-key="doc_id"
            :server-items-length="doc_items.total"
            :options.sync="pagination"
            mobile-breakpoint="50"
            :footer-props="{ 'items-per-page-options': pagination_settings.perPageList }"
          >
            <template v-slot:item.data-table-expand="{ item, isExpanded,expand }">
              <v-icon
                v-if="isExpanded && item.reports.length > 1"
                @click="expand(!isExpanded)"
              >mdi-chevron-up</v-icon>
              <v-icon
                v-if="!isExpanded && item.reports.length > 1"
                @click="expand(!isExpanded)"
              >mdi-chevron-down</v-icon>
            </template>
            <template v-slot:item.checkbox="{item}" class="td">
              <v-simple-checkbox v-model="item.selected" :ripple="false"></v-simple-checkbox>
            </template>
            <template v-slot:item.file_type="{item}" class="td">
              <v-img
                :src="(item.report_name_id > 0)?'images/icons/pdf.svg':'images/icons/'+getExtension(item.doc_path)+'.svg'"
                height="30"
                width="30"
                lazy-src="images/icons/file.svg"
              ></v-img>
            </template>
            <template v-slot:item.doc_type="{item}" class="td">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">{{item.doc_type.title}}</span>
                </template>
                <span>{{item.doc_title}}</span>
              </v-tooltip>
            </template>

            <!-- <template v-slot:item.doc_type="{item}" class="td">
                <span>{{item.doc_type.title}}</span> <span style="font-size:10px !important;color:#816c6c">({{item.doc_title}})</span>
            </template>-->
            <template
              v-slot:item.created_at="{item}"
              class="td"
            >{{displayDateTimeFormate(item.created_at,'date')}}</template>
            <template
              v-slot:item.updated_at="{item}"
              class="td"
            >{{displayDateTimeFormate(item.updated_at,'date')}}</template>
            <template v-slot:item.action="{item}">
              <v-btn icon @click="setSlider(item)">
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <template v-slot:expanded-item="{ item }">
              <td colspan="9" class="pa-0">
                <v-simple-table dense>
                  <tbody>
                    <tr v-for="(row, index) in item.reports" :key="index">
                      <td style="width: 35px; min-width: 34px;" v-if="item.doc_id != row.doc_id"></td>
                      <td width="4.3%" class="text-center" v-if="item.doc_id != row.doc_id">
                        <v-simple-checkbox v-model="row.selected" :ripple="false"></v-simple-checkbox>
                      </td>
                      <td width="45%" v-if="item.doc_id != row.doc_id">{{row.doc_title}}</td>
                      <td width="5%" v-if="item.doc_id != row.doc_id">
                        <v-img
                          :src="(row.report_name_id > 0)?'images/icons/pdf.svg':'images/icons/'+getExtension(row.doc_path)+'.svg'"
                          height="30"
                          width="30"
                          lazy-src="images/icons/file.svg"
                        ></v-img>
                      </td>
                      <td
                        width="11%"
                        v-if="item.doc_id != row.doc_id"
                      >{{displayDateTimeFormate(row.created_at,'date')}}</td>
                      <td
                        width="11%"
                        v-if="item.doc_id != row.doc_id"
                      >{{displayDateTimeFormate(row.updated_at,'date')}}</td>
                      <td width="21%" v-if="item.doc_id != row.doc_id">{{row.user.full_name}}</td>
                      <td width="4.5%" v-if="item.doc_id != row.doc_id">
                        <v-btn icon @click="setSlider(row)">
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSlider" persistent fullscreen>
      <v-card style="position: fixed;top: 0;height:100vh;" flat class="blue-grey lighten-4">
        <v-tabs vertical v-model="itemNumber" color="primary" dark show-arrows>
          <div class="tab-title" :style="{width : (drawer) ? '0' : 'auto'}">
            <v-tab v-for="(slide, i) in doc_items.data" :key="i" style="height:35px;">
              <div
                style="max-width:150px;"
                class="text-caption d-inline-block text-truncate text-sm-left"
              >
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{slide.doc_title}}</span>
                  </template>
                  <span>{{slide.doc_title}}</span>
                </v-tooltip>
              </div>
            </v-tab>
          </div>
          <v-tab-item v-for="(slide, i) in doc_items.data" :key="i" style="height:100vh;">
            <v-img
              :src="slide.doc_path"
              v-if="isImage(slide.doc_path)"
              contain
              style="max-height:100%;width:auto"
              lazy-src="images/icons/file.svg"
            ></v-img>
            <div v-else-if="isMsDoc(slide.doc_path)">
              <iframe
                :src="'https://view.officeapps.live.com/op/embed.aspx?src='+slide.doc_path"
                frameborder="0"
                style="width:100%;height:100vh"
              ></iframe>
            </div>
            <div v-else-if="isGoogleDoc(slide.doc_path)">
              <iframe
                :src="'https://docs.google.com/gview?embedded=true&url='+slide.doc_path"
                frameborder="0"
                style="width:100%;height:100vh"
              ></iframe>
            </div>
            <v-img
              src="/images/no-preview.png"
              contain
              v-else
              style="height:100%"
              lazy-src="images/icons/file.svg"
            ></v-img>
          </v-tab-item>
        </v-tabs>
        <div
          class="d-flex flex-row justify-space-between col-12 customimg"
          style="position:absolute;bottom:0px;"
        >
          <div>
            <v-btn class="mx-2" fab dark small color="primary">
              <v-icon dark>mdi-cloud-print-outline</v-icon>
            </v-btn>
            <v-btn class="mx-2" fab dark small color="primary">
              <v-icon dark>mdi-email-send-outline</v-icon>
            </v-btn>
            <v-btn class="mx-2" fab dark small color="primary">
              <v-icon dark>mdi-message-arrow-right-outline</v-icon>
            </v-btn>
          </div>
          <v-btn fab color="error" class="mx-2" bottom small @click="showSlider = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="email_dialog" persistent max-width="500">
      <v-card :loading="email_loading">
        <v-card-title>
          <span class="headline">Email Address</span>
        </v-card-title>
        <v-card-text>
          <v-row dense class="mt-3">
            <v-text-field
              label="Enter email address*"
              v-model="email_address"
              :error-messages="email_address_error"
              :hide-details="!email_address_error"
              outlined
              dense
            ></v-text-field>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="email_dialog = false;email_address = null;email_address_error = null"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="sendDocuments">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rename_file_popup" persistent max-width="500">
      <v-card :loading="email_loading">
        <v-card-title>
          <span class="headline">File Name</span>
        </v-card-title>
        <v-card-text>
          <v-row dense class="mt-3">
            <v-text-field
              label="Enter File Name*"
              v-model="form_data_temp.file_name"
              outlined
              dense
            ></v-text-field>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="form_data_temp.file_name=form_data_temp.file.name;rename_file_popup=false"
          >Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="rename_file_popup=false;">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="assign_reassign_type_module" persistent max-width="500">
      <v-card :loading="email_loading">
        <v-card-title>
          <span class="headline">Document Type</span>
        </v-card-title>

        <v-card-text>
          <v-col cols="12" class="d-flex p-0">
            <v-col cols="3" class="d-flex p-0"></v-col>
            <v-col cols="9" class="d-flex p-0">
              <v-radio-group
                v-model="doc_all"
                row
                hide-details
                class="mt-0"
                dense
                @change="setDocumentData({key : 'doc_all',value : doc_all});getDocTypes();"
              >
                <v-radio label="Add" :value="true" class="ma-0 pa-0"></v-radio>
                <v-radio label="Delete" :value="false" class="ma-0 pa-0 pl-2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-col>
          <v-col cols="12" class="d-flex p-0">
            <v-select
              style="max-width: 100%;"
              v-model="all_doc_name"
              :items="all_doc_type_list"
              dense
              outlined
              label="Select Item"
              multiple
              class="ml-5"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{ item.text}}</span>
                </v-chip>
                <span
                  v-if="index === 1"
                  class="grey--text text-caption"
                >(+{{ all_doc_name.length - 1 }} others)</span>
              </template>
            </v-select>
            <v-tooltip bottom v-if="doc_all==true && all_doc_name.length>0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="assignDocumentType();"
                  class="ml-3"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Assign document Type in Module</span>
            </v-tooltip>
            <v-tooltip bottom v-if="doc_all==false  && all_doc_name.length>0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  color="error"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteDocumentTypeAssignment();"
                  class="ml-3"
                >
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Remove Document type from Module</span>
            </v-tooltip>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="assign_reassign_type_module = false;">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay absolute :value="doc_list_loading" style="z-index:999999;">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import { mapState, mapMutations, mapActions } from "vuex";
import VueDropboxPicker from "vue-dropbox-picker";
import { parseParams } from "../../plugins/helper";

const moment = require("moment");
export default {
  name: "UploadList",
  components: {
    VueDropboxPicker
  },
  data: () => ({
    dragging: false,
    dropboxApiKey: "zq0ioqqap9ils4e",
    form_data_temp: {
      file: null,
      doc_type: "",
      doc_title: "",
      is_dropbox: false,
      dropbox_file: {},
      extra_folder: 0,
      move_module_item_id: "",
      move_doc_type: "",
      move_doc_title: "",
      move_extra_folder: 0,
      expence: false,
      move_expence: false,
      file_name: ""
    },
    //  form_data_temp : {
    //   move_module_item_id:'',
    //   doc_type : '',
    //   doc_title : '',
    //   extra_folder:0,
    // },
    // form_data_temp:{},
    is_extra_folder: false,
    is_move_extra_folder: false,
    extra_folder: 0,
    showSlider: false,
    itemNumber: 0,
    email_address: null,
    email_dialog: false,
    assign_reassign_type_module: false,
    email_address_error: null,
    drawer: false,
    email_loading: false,
    filter_menu: false,
    doc_all: true,
    all_doc_name: [],
    edit_mode: false,
    move_dialog: false,
    move_row: false,
    rename_file_popup: false,
    headers: [
      {
        value: "checkbox",
        text: "#",
        sortable: false,
        width: "2.5%",
        align: "center"
      },
      { value: "doc_type", text: "Doc Type", sortable: true, width: "20%" },
      { value: "doc_title", text: "Doc Folder", sortable: true, width: "20%" },
      { value: "client_name", text: "File", sortable: true, width: "30%" },
      { value: "file_type", text: "Type", sortable: false, width: "5%" },
      {
        value: "created_at",
        text: "Upload Dt.",
        sortable: true,
        width: "10%"
      },
      { value: "user.first_name", text: "User", sortable: false, width: "5%" },
      { value: "action", text: "View", sortable: false, width: "7.5%" }
    ],
    doc_module_status_list: [
      { value: "only_project", text: "Project" },
      { value: "only_calendar_task", text: "Calendar Task" },
      { value: "", text: "ALL" }
    ],
    doc_type_list: [],
    report_type_list: [],
    vendor_list: [],
    customer_list: [],
    project_list: [],
    project_id: "",
    project_status: "1",
    chart_of_account_list: [],
    search: "",
    pagination: {
      itemsPerPage: 10,
      sortBy: ["created_at"],
      page: 1,
      search: "",
      filters: {
        doc_type: "",
        doc_folder: "",
        doc_file: "",
        report_type: "",
        doc_module_status: "only_project"
      }
    },
    file_types: {
      images: ["png", "jpg", "jpeg", "svg", "bmp"],
      iframe: ["pdf", "csv"]
    },
    project_status_list: [
      { text: "All", value: "all" },
      { text: "Active", value: "1" },
      { text: "Inactive", value: "0" }
    ],
    pagination_settings: {
      perPageList: ["All", 10, 20, 25, 30, 50, 100],
      itemsPerPage: 30
    }
  }),
  watch: {
    form_data: {
      handler() {
        this.form_data_temp = {
          file: null,
          doc_type: "",
          doc_title: "",
          is_dropbox: false,
          dropbox_file: {},
          extra_folder: 0
        };
        this.getProjects();
        this.getDocuments(parseParams(this.pageData));
        this.getVendors();
        this.getCustomers();
        this.getChartOfAccount();
        this.getModuleItemList();
      }
    },
    project_id: {
      handler(val) {
        if (val) {
          console.log(val, "val");
          this.setDocumentData({ key: "o_id", value: val });
          this.getDocuments(parseParams(this.pageData));
          this.getModuleItemList();
          this.getVendors();
          this.getCustomers();
          this.getChartOfAccount();
          this.getDocTypes(parseParams(this.pageData));
          this.getReportName();
        } else {
          this.doc_items.data = [];
        }
      }
    },
    doc_list_modal: {
      handler(val) {
        if (!val) {
          this.form_data_temp = {
            file: null,
            doc_type: "",
            doc_title: "",
            is_dropbox: false,
            dropbox_file: {},
            extra_folder: 0
          };
          this.setDocumentData({ key: "form_errors", value: [] });
        } else {
          this.project_id = "";
          this.project_status = "1";
          this.is_extra_folder = false;
          this.move_row = false;
          this.move_dialog = false;
          this.is_move_extra_folder = false;
          if (this.main_task_id != 0) {
            this.pagination.filters.doc_module_status = "only_calendar_task";
          }

          this.getProjects();
          this.getDocuments(parseParams(this.pageData));
          if (this.o_id) {
            this.getModuleItemList();
            this.getVendors();
            this.getCustomers();
            this.getChartOfAccount();
            this.getDocTypes(parseParams(this.pageData));
            this.getReportName();
          }
        }
      }
    },
    refresh_doc_list: {
      handler() {
        this.form_data_temp = {
          file: null,
          doc_type: "",
          doc_title: "",
          is_dropbox: false,
          dropbox_file: {},
          extra_folder: 0
        };
        this.setDocumentData({ key: "form_errors", value: [] });
        this.getDocuments(parseParams(this.pageData));
        this.getDocTypes(parseParams(this.pageData));
      }
    },
    pagination: {
      handler() {
        if (this.pageData.itemsPerPage == "All") {
          this.pageData.itemsPerPage = -1;
        }
        this.getDocuments(parseParams(this.pageData));
        this.getDocTypes(parseParams(this.pageData));
        this.getModuleItemList(parseParams(this.pageData));
      },
      deep: true
    }
  },
  computed: {
    ...mapState("document", [
      "doc_list_loading",
      "doc_list_modal",
      "form_name",
      "bank_name",
      "project_name",
      "vendor_name",
      "item_name",
      "job_name",
      "user_name",
      "customer_name",
      "item",
      "form_data",
      "doc_items",
      "type",
      "form_errors",
      "doc_types",
      "doc_types_filter",
      "doc_folder_filter",
      "report_names",
      "refresh_doc_list",
      "all_doc_type_list",
      "doc_module",
      "main_task_id",
      "child_task_id",
      "chart_of_account_name",
      "module_item_list",
      "o_id",
      "is_from_dashboard",
      "is_moved"
    ]),
    // ...mapState("utils", ["pagination_settings"]),
    pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
    selectedRows2() {
      let returnData = [];
      if (this.doc_items.data) {
        this.doc_items.data.filter(function(item) {
          if (item.selected) {
            returnData.push(item);
          }
          if (item.reports.length > 0) {
            item.reports.filter(function(item2) {
              if (item2.selected) {
                returnData.push(item2);
              }
            });
          }
        });
      }
      return returnData;
      // if(this.doc_items.data) {
      //   return this.doc_items.data.filter(function (item) {
      //     return item.selected == true;
      //   });
      // } else {
      //   return []
      // }
    }
  },
  methods: {
    ...mapActions("document", [
      "uploadFiles",
      "getDocTypes",
      "getReportName",
      "getDocuments",
      "moveFiles",
      "getModuleItemList"
    ]),
    ...mapMutations("document", ["setDocumentData"]),
    ...mapMutations("utils", ["setAlert"]),

    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
    },
    // getDocumentsAllList(){
    //    this.getDocuments(parseParams(this.pageData));
    // },
    getFileDetail() {
      this.edit_mode = true;
      this.form_data_temp.move_module_item_id = this.o_id;

      this.form_data_temp.doc_id = this.selectedRows2[0].doc_id;
      // this.form_data_temp.move_doc_id=this.selectedRows2[0].doc_id

      this.form_data_temp.doc_type = this.selectedRows2[0].doc_type.doctype_id;
      this.form_data_temp.move_doc_type = this.selectedRows2[0].doc_type.doctype_id;

      this.form_data_temp.extra_folder = this.selectedRows2[0].extra_folder;
      this.form_data_temp.move_extra_folder = this.selectedRows2[0].extra_folder;

      if (this.selectedRows2[0].extra_folder != 0) {
        this.is_extra_folder = true;
        this.is_move_extra_folder = true;
      } else {
        this.is_extra_folder = false;
        this.is_move_extra_folder = false;
      }
      this.form_data_temp.doc_title = this.selectedRows2[0].doc_title;
      this.form_data_temp.move_doc_title = this.selectedRows2[0].doc_title;
      this.form_data_temp.client_name = this.selectedRows2[0].client_name;
      this.form_data_temp.file_name = this.selectedRows2[0].client_name;
      this.form_data_temp.move_file_name = this.selectedRows2[0].client_name;
    },
    getDocumentsList() {
      this.getDocTypes(parseParams(this.pageData));
    },
    createFile(file) {
      this.form_data_temp.file = file;
      this.form_data_temp.file_name = file.name;
      this.dragging = false;
    },
    removeFile() {
      this.form_data_temp.file = "";
    },
    renameFile() {
      this.form_data_temp.file_name = this.form_data_temp.file.name;
      this.rename_file_popup = true;
    },
    renameDropBoxFile() {
      this.form_data_temp.file_name = this.form_data_temp.dropbox_file.name;
      this.rename_file_popup = true;
    },
    ChangeFileName() {},
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    resetFilter() {
      this.pagination.search = "";
      this.pagination.filters.report_type = "";
      this.pagination.filters.doc_type = "";
      this.pagination.filters.doc_folder = "";
      this.pagination.filters.doc_file = "";
      this.pagination.filters.doc_module_status = "only_project";
      this.getDocuments();
    },

    resetData() {
      this.form_data_temp = {
        file: null,
        doc_type: "",
        doc_title: "",
        client_name: "",
        is_dropbox: false,
        dropbox_file: {},
        extra_folder: 0,
        move_extra_folder: 0,
        move_doc_type: "",
        move_doc_title: "",
        file_name: ""
      };
      this.is_extra_folder = false;
      this.is_move_extra_folder = false;
      this.edit_mode = false;
      this.move_row = false;
    },
    setDocTitle() {
      let _self = this;
      let type = this.doc_types.filter(type => {
        return type.value == _self.form_data_temp.doc_type;
      });
      this.form_data_temp.doc_title = type[0].doc_folder
        ? type[0].doc_folder
        : "";
      this.form_data_temp.extra_folder = type[0].extra_folder;
      if (
        this.form_data_temp.doc_title == "" ||
        this.form_data_temp.doc_title == "null"
      ) {
        this.is_extra_folder = true;
        if (type[0].extra_folder == 1) {
          this.form_data_temp.doc_title = this.customer_name;
        }
        if (type[0].extra_folder == 2) {
          this.form_data_temp.doc_title = this.vendor_name;
        }
        if (type[0].extra_folder == 3) {
          this.form_data_temp.doc_title = this.chart_of_account_name;
        }
      } else {
        this.is_extra_folder = false;
        this.form_data_temp.extra_folder = 0;
      }
    },
    setMoveDocTitle() {
      let _self = this;
      let type = _self.doc_types.filter(type => {
        return type.value == _self.form_data_temp.move_doc_type;
      });
      _self.form_data_temp.move_doc_title = type[0].doc_folder
        ? type[0].doc_folder
        : "";
      _self.form_data_temp.move_extra_folder = type[0].extra_folder;
      if (
        _self.form_data_temp.move_doc_title == "" ||
        _self.form_data_temp.move_doc_title == "null"
      ) {
        _self.is_move_extra_folder = true;
        if (type[0].extra_folder == 1) {
          // _self.form_data_temp.move_doc_title=_self.customer_name
          _self.getCustomerName(_self.form_data_temp.move_module_item_id);
        }
        if (type[0].extra_folder == 2) {
          _self.form_data_temp.move_doc_title = _self.vendor_name;
        }
        if (type[0].extra_folder == 3) {
          _self.form_data_temp.move_doc_title = _self.chart_of_account_name;
        }
      } else {
        _self.is_move_extra_folder = false;
        _self.form_data_temp.move_extra_folder = 0;
      }
    },
    onCancel() {
      console.log("onCancel");
      this.form_data_temp.dropbox_file = {};
    },
    onPicked(files) {
      this.form_data_temp.dropbox_file = files[0];
      this.form_data_temp.file_name = files[0].name;
    },
    displayDateTimeFormate(date, flag) {
      if (flag == "time") {
        return moment(date).format("H:mm:ss");
      } else {
        return moment(date).format("MM/DD/YYYY");
      }
    },
    async uploafileFolder(data) {
      await this.uploadFiles(data);
      if (this.form_errors.length == 0) {
        this.is_extra_folder = false;
        this.resetData();
      }
      this.getDocTypes(parseParams(this.pageData));
      this.getDocuments(parseParams(this.pageData));
      this.setDocumentData({ key: "doc_list_loading", value: false });
    },
    async moveFile(data) {
      await this.moveFiles(data);
      if (!this.is_moved) {
        this.setAlert({
          show: true,
          variant: "error",
          message: "Something went wrong!! Please move again",
          dismissCountDown: 0
        });
        this.setDocumentData({ key: "doc_list_loading", value: false });
      }
      if (this.form_errors.length == 0) {
        this.is_extra_folder = false;
        this.is_move_extra_folder = false;
        this.resetData();
      }

      this.getDocuments(parseParams(this.pageData));
      this.getDocTypes(parseParams(this.pageData));
    },
    setSlider(item) {
      // this.itemNumber = this.doc_items.data.indexOf(item);
      // this.showSlider = true;
      window.open(item.dropbox_url, "_blank");
      // let routeData = this.$router.resolve({ name: 'document_view', params: { type: item.type, o_id: item.o_id, doc_id: item.doc_id, doc_type:this.pagination.filters.doc_type ? this.pagination.filters.doc_type :0, doc_folder:this.pagination.filters.doc_folder ?this.pagination.filters.doc_folder :0} })
      // window.open(routeData.href, '_blank');
      // item.dropbox_url= 'https://www.dropbox.com/scl/fi/ze0sfxvfb3n1rzo5x4f8v/Pay-25000-090820_01.jpg?rlkey=17odhjdgajygndh6qx9yqficl&dl=0';
      // var link = document.createElement("a");
      // var modifiedUrl = item.dropbox_url.replace(
      //   "www.dropbox.com",
      //   "dl.dropboxusercontent.com"
      // );
      // link.href = modifiedUrl;
      // link.target = "_blank";
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.user_id == itemData.item.user_id) {
            item.selected = true;
          }
          return item;
        });
      }
    },
    deleteDocuments() {
      let _self = this;
      let ids = [];
      this.setDocumentData({ key: "doc_list_loading", value: true });
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);

      this.selectedRows2.map(function(item) {
        ids.push(item.doc_id);
      });
      axios
        .post("delete_document", {
          ids: ids,
          company_id: company_data.company_id
        })
        .then(function() {
          _self.getDocuments();
          // _self.setAlert({
          //     show: true,
          //     variant: "primary",
          //     message: response.data.message,
          //     dismissCountDown: 0,
          //   });
          _self.item.docs_count = _self.item.docs_count - ids.length;
          this.setDocumentData({ key: "doc_list_loading", value: false });
          //_self.form_data.docs_count = _self.form_data.docs_count - ids.length
        })
        .catch(function() {
          console.log("FAILURE!!");
          this.setDocumentData({ key: "doc_list_loading", value: false });
        });
    },
    sendDocuments() {
      let _self = this;
      let ids = [];
      this.selectedRows2.map(function(item) {
        ids.push(item.doc_id);
      });
      _self.email_loading = true;
      axios
        .post("send_document", {
          ids: ids,
          email_id: _self.email_address
        })
        .then(function(response) {
          _self.email_loading = false;
          let data = response.data;
          if (!data.status) {
            _self.form_loading = false;
            for (let key in data.errors) {
              _self.email_address_error = data.errors[key][0];
            }
          } else {
            _self.email_address = null;
            _self.email_dialog = false;
            _self.email_address_error = null;
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
            _self.getDocuments();
          }
        })
        .catch(function() {
          _self.email_loading = false;
          console.log("FAILURE!!");
        });
    },
    assignDocumentType() {
      let _self = this;
      console.log("_self.doc_module", _self.doc_module);
      axios
        .post("assign_document_type", {
          doc_ids: _self.all_doc_name,
          module: _self.doc_module
        })
        .then(function() {
          _self.all_doc_name = [];
          _self.getDocTypes(parseParams(_self.pageData));
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    deleteDocumentTypeAssignment() {
      let _self = this;
      axios
        .post("delete_document_type_assignment", {
          doc_ids: _self.all_doc_name,
          module: _self.doc_module
        })
        .then(function() {
          _self.all_doc_name = [];
          _self.getDocTypes(parseParams(_self.pageData));
        })
        .catch(function() {
          console.log("FAILURE!!");
        });
    },
    getExtension(path) {
      let splitPath = path.split(".");
      splitPath = splitPath[splitPath.length - 1];
      return splitPath;
    },
    getCustomerName(project_id) {
      let _self = this;
      let customer_detail = this.module_item_list.filter(type => {
        if (type.value == project_id) {
          return type.customer_id;
        }
      });
      _self.form_data_temp.move_doc_title = customer_detail[0].customer_name;
      console.log(
        "_self.form_data_temp.move_doc_title",
        _self.form_data_temp.move_doc_title
      );
    },
    isImage(path) {
      if (
        ["png", "jpeg", "jpg", "bmp", "svg"].includes(this.getExtension(path))
      ) {
        return true;
      } else {
        return false;
      }
    },
    isGoogleDoc(path) {
      if (["pdf", "txt", "rtf"].includes(this.getExtension(path))) {
        return true;
      } else {
        return false;
      }
    },
    isMsDoc(path) {
      if (
        ["csv", "doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(
          this.getExtension(path)
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getProjects() {
      let _self = this;
      axios
        .get("get_project_by_status?status=" + _self.project_status)
        .then(function(res) {
          _self.project_list = res.data.data;
        })
        .catch(function() {});
    },
    getVendors() {
      let _self = this;
      axios
        .get("get_vendors")
        .then(function(res) {
          _self.vendor_list = res.data.data;
        })
        .catch(function() {});
    },
    getCustomers() {
      let _self = this;
      axios
        .get("get_customers_list")
        .then(function(res) {
          _self.customer_list = res.data.data;
        })
        .catch(function() {});
    },
    getChartOfAccount() {
      let _self = this;
      axios
        .get("get_chart_of_account_list")
        .then(function(res) {
          _self.chart_of_account_list = res.data.data;
        })
        .catch(function() {});
    },
    setFocus(className) {
      console.log("className", className);
      document.querySelectorAll("." + className + " input")[0].focus();
    }
  },
  mounted: function() {
    this.is_extra_folder = false;
    this.move_row = false;
    this.is_move_extra_folder = false;
    this.form_data_temp.is_dropbox = false;
  }
};
</script>

<style scoped>
.theme--dark.v-tabs > .v-tabs-bar {
  background-color: #1e1e1e7a !important;
}
.dropZone {
  width: 100%;
  height: 40px;
  position: relative;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
}

.dropZone:hover {
  border: 1px solid #689132;
}

.dropZone:hover .dropZone-title {
  color: #a8a8a8;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #7c7c77;
  font-size: 16px;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #689132;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 40px;
  position: relative;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #689132;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}
.dropZone-uploaded-info .dropZone-title {
  color: #689132;
}

.removeFile {
  width: 15px;
  align: right;
}
.close_icon {
  color: #689132;
}
.error_message {
  color: #a61f38;
  size: 12px;
}
</style>